export default __webpack_public_path__ + "static/media/videocamera.a8650602.svg";